<template>
  <HeaderTitle single back-target="settings">
    <template #bottom>{{
      $t("profile.screen.about.section.terms.tile")
    }}</template>
  </HeaderTitle>
  <BasicWrapper white>
    <legal-text v-if="!isLoading" :text="clientStore.getToc"></legal-text>
  </BasicWrapper>
</template>

<script>
import BasicWrapper from "../../components/v2/layout/pageWrapper/BasicWrapper.vue";
import LegalText from "../../components/v2/legal/legalText.vue";
import { useClientStore } from "../../store/v2/client";
import HeaderTitle from "../../components/v2/layout/header/HeaderTitle.vue";

export default {
  name: "TermsOfServicePage",
  components: { LegalText, BasicWrapper, HeaderTitle },
  setup() {
    const clientStore = useClientStore();

    return {
      clientStore,
    };
  },
  data() {
    return {
      isLoading: true,
    };
  },
  async mounted() {
    await this.clientStore
      .getClient(null, this.$route.params.slug)
      .then(() => {
        this.isLoading = false;
      })
      .catch((err) => {
        this.$userAuthenticator.logout();
        this.$router.push({
          name: "maintenancePage",
        });
      });
  },
};
</script>
